import { TablePagination } from "@mui/material";
import type { ChangeEvent, FC } from "react";

type CustomPaginationProps = {
  count: number;
  page: number;
  onPageChange: (newPage: number) => void;
  rowsPerPage: number;
  onRowsPerPageChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const CustomPagination: FC<CustomPaginationProps> = ({
  count,
  page,
  onPageChange,
  rowsPerPage,
  onRowsPerPageChange,
}) => (
  <TablePagination
    component="div"
    count={count}
    page={page}
    onPageChange={(_e, newPage) => onPageChange(newPage)}
    rowsPerPage={rowsPerPage}
    onRowsPerPageChange={onRowsPerPageChange}
    rowsPerPageOptions={[10, 25, 50, 100]}
    labelRowsPerPage="每页行数:"
    labelDisplayedRows={({ from, to, count }) =>
      `${from} - ${to} 总数: ${count}`
    }
    sx={{
      "& .MuiTablePagination-select": {
        fontWeight: "bold",
      },
      "& .MuiTablePagination-displayedRows": {
        fontWeight: "bold",
      },
      "& .MuiTablePagination-selectLabel": {
        fontWeight: "bold",
      },
    }}
  />
);
